import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'app-compound-header',
  template: `<span class="ag-header-cell-text">{{ displayName }}</span>`
})
export class CompoundHeaderComponent implements IHeaderAngularComp {
  public displayName: string = '';

  agInit(params: IHeaderParams): void {
    this.updateDisplayName(params);
  }

  refresh(params: IHeaderParams): boolean {
    this.updateDisplayName(params);
    return true;
  }

  private updateDisplayName(params: IHeaderParams): void {
    const colDef: any = params.column.getColDef();
    this.displayName = colDef.pivotValueColumn?.userProvidedColDef?.headerName || colDef.headerName || '';
  }
}
